<ng-template #latestinfosmodal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">
      Dépôt d'un ticket
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <h5>Voici les dernières informations susceptibles de vous concerner :</h5>
    @for (info of infos; track info) {
      <app-info-block [info]="info"></app-info-block>
    }
    <a routerLink="/informations" (click)="modal.dismiss()">
      <fa-icon icon="arrow-right"></fa-icon>&nbsp;Consulter le fil d'information
    </a>
  </div>
  <div class="modal-footer">
    <app-cancel-button (click)="modal.dismiss()"></app-cancel-button>
    <button type="button" class="btn btn-primary" (click)="modal.close()">Déposer un ticket</button>
  </div>
</ng-template>
